/* eslint-disable eqeqeq */
import React, { useState } from "react";
import { Button } from "../../../components/ui/button";
import { ResponsiveDrawerForm } from "../../../components/ResponsiveDrawerForm";
import { getModuleNamingBySlug } from "../../../lib/Misc";
import { useOrganization } from "../../../lib/context/OrganisationContext";
import AddEditVendor from "../../Vendors/AddEditVendor";
import AddEditContact from "../../Contacts/AddEditContact";
import AddEditBeneficary from "../../Beneficiarys/AddEditBeneficary";
import AddEditJointAccount from "../../JointAccounts/AddEditJointAccount";

const KYCIncomplete = ({
  contactType,
  contact,
  type,
  entityType,
  fetchData,
  amlCTFEnable,
}) => {
  const { organizationData } = useOrganization();
  const [edit, setEdit] = useState(true);
  const [showAddEditVendor, setShowAddEditVendor] = useState(false);
  const [showAddEditContact, setShowAddEditContact] = useState(false);
  const [showAddEditBeneficary, setShowAddEditBeneficary] = useState(false);
  const [showAddEditJointAccount, setShowAddEditJointAccount] = useState(false);

  const toggleShowAddEditVendor = () => {
    setEdit(true);
    setShowAddEditVendor(!showAddEditVendor);
  };

  const toggleShowAddEditContact = () => {
    setEdit(true);
    setShowAddEditContact(!showAddEditContact);
  };

  const toggleShowAddEditBeneficary = () => {
    setEdit(true);
    setShowAddEditBeneficary(!showAddEditBeneficary);
  };

  const toggleShowAddEditJointAccount = () => {
    setEdit(true);
    setShowAddEditJointAccount(!showAddEditJointAccount);
  };

  return (
    <>
      <Button
        size={"sm"}
        className="h-6 px-2"
        onClick={() => {
          if (contactType == 1) {
            toggleShowAddEditVendor();
          } else if (contactType == 2) {
            toggleShowAddEditContact();
          } else if (contactType == 3) {
            toggleShowAddEditBeneficary();
          } else if (contactType == 4) {
            toggleShowAddEditJointAccount();
          }
        }}
      >
        {type == "1"
          ? "Complete KYC"
          : type == "2" && entityType == "1"
            ? "Complete KYB"
            : "Add Beneficary"}
      </Button>

      {contactType == 1 ? (
        <>
          <ResponsiveDrawerForm
            description={""}
            title={`${getModuleNamingBySlug(
              organizationData?.organizationData,
              "vendors",
              "Vendor",
            )} Onboarding Assessment`}
            handleOpen={() => {}}
            handleClose={() => {
              setEdit(false);
              setShowAddEditVendor(false);
            }}
            buttonText={""}
            className={"overflow-hidden"}
            open={showAddEditVendor}
            buttonClassName={""}
            setOpen={setShowAddEditVendor}
            mobileCancelHidden={true}
            write={true}
          >
            <AddEditVendor
              edit={edit}
              setEdit={setEdit}
              onlyKyc={true}
              toggleShowAddEditVendor={toggleShowAddEditVendor}
              vendorID={contact?.id}
              fetchKYCData={() => fetchData()}
              org={true}
              amlCTFEnable={amlCTFEnable}
            />
          </ResponsiveDrawerForm>
        </>
      ) : contactType == 2 ? (
        <ResponsiveDrawerForm
          description={""}
          title={`${getModuleNamingBySlug(
            organizationData?.organizationData,
            "contacts",
            "Customer",
          )} Onboarding Assessment`}
          handleOpen={() => {}}
          handleClose={() => {
            setEdit(false);
            setShowAddEditContact(false);
          }}
          buttonText={""}
          className={"overflow-hidden"}
          open={showAddEditContact}
          buttonClassName={""}
          setOpen={setShowAddEditContact}
          write={true}
        >
          <AddEditContact
            edit={edit}
            toggleShowAddEditContact={toggleShowAddEditContact}
            id={contact?.id}
            setEdit={setEdit}
            onlyKyc={true}
            fetchKYCData={() => fetchData()}
            org={true}
            amlCTFEnable={amlCTFEnable}
          />
        </ResponsiveDrawerForm>
      ) : contactType == 3 ? (
        <>
          <ResponsiveDrawerForm
            description={""}
            title={`Beneficaries Onboarding Assessment`}
            handleOpen={() => {}}
            handleClose={() => {
              setEdit(false);
              setShowAddEditBeneficary(false);
            }}
            buttonText={""}
            className={"overflow-hidden"}
            open={showAddEditBeneficary}
            buttonClassName={""}
            setOpen={setShowAddEditBeneficary}
            mobileCancelHidden={true}
            write={true}
          >
            <AddEditBeneficary
              edit={edit}
              setEdit={setEdit}
              onlyKyc={true}
              toggleShowAddEditBeneficary={toggleShowAddEditBeneficary}
              id={contact?.id}
              fetchKYCData={() => fetchData()}
              org={true}
              amlCTFEnable={amlCTFEnable}
            />
          </ResponsiveDrawerForm>
        </>
      ) : contactType == 4 ? (
        <>
          <ResponsiveDrawerForm
            description={""}
            title={`Joint Account Onboarding Assessment`}
            handleOpen={() => {}}
            handleClose={() => {
              setEdit(false);
              setShowAddEditJointAccount(false);
            }}
            buttonText={""}
            className={"overflow-hidden"}
            open={showAddEditJointAccount}
            buttonClassName={""}
            setOpen={setShowAddEditJointAccount}
            mobileCancelHidden={true}
            write={true}
          >
            <AddEditJointAccount
              edit={edit}
              setEdit={setEdit}
              onlyKyc={true}
              toggleShowAddEditJointAccount={toggleShowAddEditJointAccount}
              id={contact?.id}
              fetchKYCData={() => fetchData()}
              org={true}
              amlCTFEnable={amlCTFEnable}
            />
          </ResponsiveDrawerForm>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default KYCIncomplete;
